import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";
import {CropsView} from "./CropsView";

// С11 — Обобщени култури по ползвател (З1). Щ6: таблиците и тортата живеят в
// CropsView — същите ги показва и публичният линк.
export const ReportCrops = () => {
    const {year, bullstat} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/crops/${year}/${bullstat}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/crops/${year}/${bullstat}?format=pdf`, `S11_${bullstat}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c = data.company;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С11 — Обобщени култури по ползвател</h5>
                    <div>{c.company_name}, Булстат: {c.bullstat}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            <CropsView data={data}/>
        </div>
    );
};
